<template>
  <div class="productSort">
    <radius-box :titleList="titleList" @setTitle="setTitleIndex">
      <template>
        <div class="content-box">
          <div class="top-img-box">
            <img :src="boxpPicUrlList[currIndex] ? boxpPicUrlList[currIndex] : defaultPic" alt="">
          </div>
          <div class="box-content-list">
            <div v-for="(item, index) in productList" :key="index" class="content-item" @click="goView(item.id)">
              <div class="top-box-item">
                <div class="product-name"> {{ item.name }} </div>
                <div class="box-info-content">
                  <div class="product-img">
                    <img v-lazy="item.picUrl" alt="">
                  </div>
                  <div class="price-info">
                    <div class="info-text">
                      <div class="sell-count">已报名：{{ item.sales }}人</div>                   
                    </div> 
                    <div class="original-price">名额数: {{ item.stock }} </div>   
                    <div class="now-price">活动价: ￥ {{ item.price }} </div>
                                     
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </radius-box>
  </div>
</template>
<script>
import { getCategory, getProducts2 } from "@api/store"
import RadiusBox from '@components/common/radiusBox/RadiusBox';


export default {
  name: "GoodsClass",
  components: { 
    RadiusBox 
  },
  data() {
    return {
      currIndex: 0, 
      titleList: [],
      productList: [],
      dataList: [],
      boxpPicUrlList: [],
      defaultPic: require('@assets/images/common/transparency.png') //默认透明图片
    };
  },
  mounted() {
    this.loadCategoryData(); //请求种类数据
  },
  methods: {
    setTitleIndex(index) {
      this.currIndex = index;
      this.productList.splice(0, this.productList.length);
      this.loadProductData(); //请求产品数据
    },
    loadCategoryData() {
      getCategory().then(res => {
        const resList = res.data;
        for (let item of resList) {
          for(let item_mix of item.children) {
            this.titleList.push({
              name: item_mix.cate_name,
              id: item_mix.id,
              picUrl: item_mix.pic
            })   
            this.boxpPicUrlList.push(item_mix.pic);  
            this.dataList.push(0);
          }
        }
        this.loadProductData(); //请求产品数据
      });
    },
    loadProductData() {
      if (this.dataList[this.currIndex]) {
        for (let item of this.dataList[this.currIndex]) {
          this.productList.push(item);
        }
      }else {
        getProducts2({ page: 1, sid: this.titleList[this.currIndex].id, limit: 10 }).then(res => {
          const resList = res.data;
          let resdata = []
          for (let item of resList) {
            resdata.push({
              name: item.store_name,
              id: item.id,
              sales: item.sales,
              picUrl: item.image,
              price: item.price,
              newPrice: item.vip_price,
              stock:item.stock
            })
          }
          this.dataList.splice(this.currIndex, 1, resdata);
          this.productList.push(...resdata);
        })
      }
    },
    goView(id) {
      this.$router.push(`/detail/${id}`);
    }
  },
}
</script>

<style scoped>
.productSort {
  width: 100vw;
  height: 100vh;
  overflow: hidden;
}
    .product-name {
      font-size: 0.27rem;
      font-weight: 600;
      margin-bottom: 0.1rem;
    }
    .top-img-box {
      height: 3.7rem;
      text-align: right;
      margin: 10px;    
      
    }
    .top-img-box img {
      width: 100%;
      max-height: 100%;
      border-radius: 10px;
    }
    .box-content-list {
      margin-bottom: 0.4rem;
      padding: 0 0.4rem;
      box-sizing: border-box;
    }
      .content-item {
        width: 100%;
        min-height: 2.4rem;
        background-color: white;
        border-radius: 0.4rem;
        margin-top: 0.4rem;
        box-sizing: border-box;
        padding: 0.3rem;
        padding-top: 0.2rem;
      }
      .box-info-content {
        display: flex;
      }
      .price-info {
        text-align: right;
        flex: 1;
      }
        .price-info > div {
          width: 100%;
          margin-bottom: 4px;
        }
        .sell-count {
          color: rgb(172, 172, 172);
          font-size: 10px;
        }
        .top-box-item {
          height: auto;
        }
          .product-img {
            height: auto;
            width: auto;
          }
          .product-img img {
            width: 1.5rem;
            height: 1.5rem;
            vertical-align: middle;
            border-radius: 0.2rem;
          }
          .now-price {
            font-size: 14px;
            font-weight: 600;
            color: rgb(240, 59, 59);
          }
</style>